// src/utils/formatId.js
export function formatUserId(id, prefix = "USR-", digits = 3) {
  return `${prefix}${String(id).padStart(digits, "0")}`;
}

// Examples:
// formatUserId(1)        → "USR-001"
// formatUserId(42)       → "USR-042"
// formatUserId(100)      → "USR-100"
// formatUserId(5, "EMP-") → "EMP-005"